import {memo} from 'react'
import {useParticipants} from '@livekit/components-react'
import {Mic} from 'lucide-react'
import {cn} from '@/shared/lib'
import {useSpeakingMap} from '../../../speaking-context'

interface ActiveSpeakersProps {
  className?: string
}

/**
 * Displays who is currently speaking in the room.
 */
export const ActiveSpeakers = memo(function ActiveSpeakers({className}: ActiveSpeakersProps) {
  const participants = useParticipants()
  const speakingMap = useSpeakingMap()

  const speakerNames = participants
    .filter(p => speakingMap.get(p.identity))
    .map(p => p.name || p.identity)
  const hasSpeakers = speakerNames.length > 0

  return (
    <div
      className={cn(
        'flex items-center flex-1 min-w-0 min-h-6 overflow-hidden justify-center sm:justify-start',
        className,
      )}
    >
      {hasSpeakers ? (
        <div className="flex items-center gap-2 min-h-6 min-w-0 w-full max-w-full overflow-hidden justify-center sm:w-auto sm:justify-start">
          <span className="flex items-center justify-center size-6 bg-primary rounded-full animate-pulse shrink-0 text-primary-foreground">
            <Mic size={12} />
          </span>
          <span className="block min-w-0 truncate text-foreground text-sm font-medium leading-6 text-center sm:text-left">
            {speakerNames.join(', ')}
          </span>
        </div>
      ) : (
        <span className="text-muted-foreground text-sm leading-6 whitespace-nowrap text-center sm:text-left">
          Никто не говорит
        </span>
      )}
    </div>
  )
})
